
document.addEventListener('click', function(event) { 
    // close search bar when clicked outside the search field
    // Check if the clicked element is the specific component or its descendant
    var specificComponent = document.querySelector('.search-modal-content');
    if (event.target !== specificComponent && !event.target.closest('.search-modal-content')) {
        document.querySelector('#header-wrapper')?.classList.remove('openSearch')
    }

    // if clicked Other Then firstLevelMenu and ourmissions menu 
    // then remove active state from megamenus
    if (!event.target.closest('.header__nav__link') && !event.target.closest('.header__topbar-link.Our.Mission') ) {
        removeActiveClassFromAllFirstLevelNav();
        setOurMissionMegamenuActive(false);
        showOverlay(false);
    }
});


document.addEventListener('DOMContentLoaded', () => mainFunction())

function mainFunction(){ //main function
    let firstLevelMenu = document.querySelectorAll('.header__main-nav .header__nav__list-item.has_sub_menu.first-level');
    firstLevelMenu.forEach(menu => {
        menu.addEventListener('click', (event) => handleFirstLevelMenuClick(event))
    })
    handleMegaMenuToggleForOurMissionInAnnounementBar()
}

function setOurMissionMegamenuActive(active){
    const ourMissionAnouncementBarNavTarget = $('.header__topbar-link.Our.Mission a');
    const ourMissionMegaMenu = $('body .header__wrapper.full-width-false .header__linklist-columns-wrapper.Our.Mission');  
    const ourMissionParentNav = $('#main-nav li.header__nav__list-item.header__nav__dropdown-linklist:has(.header__linklist-columns-wrapper.Our.Mission)')
    if(active){
        showOverlay(true)
        ourMissionAnouncementBarNavTarget[0].classList.add('active')
        ourMissionMegaMenu?.css('display', 'block');
        ourMissionParentNav?.css('display', 'inline-block');
    }
    else {
        showOverlay(false)
        ourMissionAnouncementBarNavTarget[0].classList.remove('active')
        ourMissionMegaMenu?.css('display', 'none');
        ourMissionParentNav?.css('display', 'none');
    }
}

function handleMegaMenuToggleForOurMissionInAnnounementBar(){
    $(".header__topbar-container ul.top-bar-links li.header__topbar-link.Our.Mission, body .header__wrapper.full-width-false .header__linklist-columns-wrapper.Our.Mission").click(function(){
        const ourMissionAnouncementBarNavTarget = $('.header__topbar-link.Our.Mission a');

        removeActiveClassFromAllFirstLevelNav();
        removeActiveFromAllAnnouncementBarNavsExceptOurMission()
        
        if(ourMissionAnouncementBarNavTarget[0].classList.contains('active')){
            setOurMissionMegamenuActive(false)
        }
        else{
            setOurMissionMegamenuActive(true)
        }
      });
}

function removeActiveFromAllAnnouncementBarNavsExceptOurMission(){
    const activeAnnouncementBarNavs = document.querySelectorAll('.header__topbar-link:not(.Our.Mission) a')
    activeAnnouncementBarNavs.forEach(item => item.classList.remove('active'));
}

function showOverlay(show = false){
    const overlay = document.querySelector('.menuOverlay');
    if(show){
        overlay.classList.add('active')
    }
    else {
        overlay.classList.remove('active')
    }
}

function removeActiveClassFromAllFirstLevelNav(){
    const allFirstLevelNav = document.querySelectorAll('.header__main-nav .header__nav__list-item.has_sub_menu.first-level a');
    for (let index = 0; index < allFirstLevelNav.length; index++) {
        const item = allFirstLevelNav[index];
        item.classList.remove('active')
    }
}

function removeActiveClassFromPreviouslyActiveNav(){
    const activeNav = document.querySelector('.header__main-nav .header__nav__list-item.has_sub_menu.first-level a.active');
    if(activeNav) activeNav.classList.remove('active');
}

function handleFirstLevelMenuClick(event){
    const target = event.target.closest('a')
    
    if(target.classList.contains('active')){
        target?.classList.remove('active');
        showOverlay(false)
    }
    else {
        removeActiveClassFromPreviouslyActiveNav()
        target.classList.add('active');
        showOverlay(true)
    }
    
}

